// extracted by mini-css-extract-plugin
export var layout = "_404-module--layout--HWeXt";
export var title = "_404-module--title--Zajmy";
export var description = "_404-module--description--cBnyP";
export var errorCode = "_404-module--errorCode--J-bvV";